import React, { FC, JSX } from 'react';

import { EmptyCollectionsIcon as EmptyCollections } from '@evinced-private/ui-common';

import { LoadErrorMsgLayout } from '../../../property/LoadErrorMsgLayout';

const MAIN_TITLE = 'Create your first collection';
const SECONDARY_MESSAGE =
	'Group properties by region, business unit, or any category that works for you.';

export const NoCollections: FC = (): JSX.Element => {
	return (
		<LoadErrorMsgLayout
			mainTitle={MAIN_TITLE}
			secondaryMsg={SECONDARY_MESSAGE}
			icon={EmptyCollections}
		/>
	);
};
